import TitleBar from "../components/TitleBar/TitleBar";

import "./Rules.css";

export function Rules() {
    return (
        <>
            <TitleBar title="Mythic Rules" />
            <div className="rule-page">
                <div className="category-block">
                    <h1 id="chat-rules">Chat Rules</h1>
                    <p>
                        <strong>
                            <em>Be Respectful</em>
                        </strong>
                        . Keep rude comments to yourself.
                    </p>
                    <p>
                        <strong>
                            <em>Playful</em>
                        </strong>{" "}
                        teasing is fine IF MUTUAL. If someone isn&#39;t having
                        fun, it stops. No harassment.
                    </p>
                    <p>
                        <strong>
                            <em>No Hate</em>
                        </strong>
                        . Absolute no hateful or discriminatory comments, terms,
                        phrases, or &quot;jokes&quot;.
                    </p>
                    <p>
                        <strong>
                            <em>Respect Mods</em>
                        </strong>
                        . Don&#39;t argue with them, their word is final.
                    </p>
                    <p>
                        <strong>
                            <em>Report</em>
                        </strong>
                        , don&#39;t engage. If someone is rude or offensive to
                        you, please reach out to a moderator and let them handle
                        it.
                    </p>
                    <p>
                        <strong>No Political/Religious*</strong> conversations.
                        That drama is just not welcome.
                    </p>
                    <p>
                        <strong>
                            <em>No Spam</em>
                        </strong>{" "}
                        or excessive self-promotion. No repeated messages,
                        links, or frequent self-promotion.
                    </p>
                    <p>
                        <strong>
                            <em>English</em>
                        </strong>{" "}
                        only. For moderation purposes, chat needs to stay in
                        English.
                    </p>
                </div>
                <div className="category-block">
                    <h1 id="discord-server-rules">Discord Server Rules</h1>
                    <p>
                        I aim to foster a safe, comfortable community here. As
                        such, we have a few rules.
                    </p>
                    <h2 id="1-be-respectful">1. Be Respectful</h2>
                    <p>
                        Treat everyone in the server with kindness and respect.
                        No harassment, hate speech, or discrimination will be
                        tolerated.
                    </p>
                    <h2 id="2-minors">2. Minors</h2>
                    <p>
                        Minors{" "}
                        <strong>
                            <em>are not</em>
                        </strong>{" "}
                        allowed in this server, period.
                    </p>
                    <h2 id="3-personal-information">3. Personal Information</h2>
                    <p>
                        Never share or request PII (Personal Identifying
                        Information). This includes, but is not limited to:
                    </p>
                    <ol>
                        <li>
                            Location - Asking about Country is acceptable.
                            Anything smaller than Country is unacceptable.
                        </li>
                        <li>Schools - Never acceptable</li>
                        <li>Phone Number - Never Acceptable</li>
                        <li>Email Address - Never Acceptable</li>
                    </ol>
                    <h2 id="4-keep-it-pg-13">4. Keep It PG-13</h2>
                    <p>
                        This server is meant to be safe for everyone. While some
                        swear language is allowed, keep it within reason. Posts
                        that contain multiple swear words or detail graphic
                        situations will likely be deleted.
                    </p>
                    <h2 id="5-no-spamming">5. No Spamming</h2>
                    <p>
                        Refrain from spamming messages, emojis, or links. Let
                        everyone have a chance to engage.
                    </p>
                    <h2 id="6-stay-on-topic">6. Stay On-Topic</h2>
                    <p>
                        Use channels for their intended purposes. For example,
                        keep game talk in the gaming channels and memes in the
                        meme channel. Posts that touch on both topics (Like a
                        meme about a game), use your best judgement.
                    </p>
                    <h2 id="7-promotion-of-yourself-or-others">
                        7. Promotion of yourself or others
                    </h2>
                    <p>
                        All promotions should be done in the #promo channel.
                        This includes promoting YouTube, Twitch, TikTok, etc.
                        accounts. Please limit promotions of channels to once a
                        day.
                    </p>
                    <h2 id="8-follow-twitch-discord-tos">
                        8. Follow Twitch &amp; Discord TOS
                    </h2>
                    <p>
                        Ensure your behavior complies with Twitch&#39;s,
                        YouTube&#39;s, and Discord&#39;s Terms of Service.
                    </p>
                    <h2 id="9-no-nsfw-content-ever">9. No NSFW Content EVER</h2>
                    <p>
                        Sharing explicit or NSFW content is strictly prohibited
                        in all channels at all times without exception.{" "}
                    </p>
                    <h2 id="10-use-appropriate-usernames-and-avatars">
                        10. Use Appropriate Usernames and Avatars
                    </h2>
                    <p>
                        Choose usernames and avatars that are non-offensive and
                        comply with all server rules. Inappropriate names will
                        be given a temporary nickname by moderators and a DM
                        will be sent, requesting the user change their nickname
                        in the server.
                    </p>
                    <h2 id="11-do-not-dm-or-send-friend-requests-to-others-from-the-server-without-getting-their-consent-ahead-of-time-">
                        11. Do not DM or send friend requests to others from the
                        server without getting their consent ahead of time.
                    </h2>
                    <h2 id="12-report-issues-">12. Report Issues!</h2>
                    <p>
                        If someone is breaking the rules or if there’s a
                        conflict, please submit a report in #ticket with as much
                        info as possible. The @Support or @Mod will do their
                        best to help you. If there is an active and ongoing
                        issue in a chat channel, however, feel free to @Support
                        on the issue.
                    </p>
                    <h2 id="13-have-fun-and-engage-">
                        13. Have Fun and Engage!
                    </h2>
                    <p>
                        This community is all about positivity and gaming! Make
                        friends, join discussions, and enjoy the server.
                    </p>
                    <h1 id="disciplinary-action">Disciplinary Action</h1>
                    <p>
                        Mods will review each case as they happen, however, the
                        general flow will be as follows:
                    </p>
                    <h2 id="first-minor-offense-">First minor offense:</h2>
                    <ol>
                        <li>The offending message(s) will be deleted.</li>
                        <li>
                            The user(s) responsible for the message(s) will be
                            warned for their behavior.
                        </li>
                        <li>
                            The user(s) responsible for the message(s){" "}
                            <em>may</em> be muted for up to 24 hours if
                            necessary.
                        </li>
                    </ol>
                    <h2 id="repeat-minor-offenses-or-first-major-offense-">
                        Repeat minor offenses or first major offense:
                    </h2>
                    <p>
                        If someone is found to have repeatedly and frequently
                        violated the rules of the server in minor ways, they can
                        and will be banned. I, Abyss, will review all bans to
                        ensure that my mods never abuse this power. If I feel a
                        ban has been wrongly given, I will rescind the ban and
                        attempt to reach out to the banned member(s).
                    </p>
                </div>
            </div>
        </>
    );
}
